import React, { useState } from "react";
import * as moment from "moment";
import { Link } from "react-router-dom";
import { INVEST_OPTIONS } from "../../../../../../../../constants";
import { Util } from "../../../../../../../../helpers/util";
import "./SilverInvestmentDetails.css";

const ConfirmInvestment = ({ setPage }) => {
  const options = Util.get(INVEST_OPTIONS);
  const [hasAgreed, setHasAgreed] = useState(false);

  const handleAgreeChange = () => setHasAgreed(!hasAgreed);

  if (!options) {
    return null;
  }

  const {
    duration,
    amount,
    interestRate,
    estimatedReturns,
    lastMonthRoi,
    monthlyRoi,
  } = options;

  const { currency } = Util.getCurrency();
  return (
    <div className="confirminvestment">
      <div className="startinvestment-main">
        <div className="confirminvestment-main">
          <h5 className="confirminvestment-h5"> Confirm Investment</h5>
          <p className="confirminvestment-textbody mt-2">
            Invest in silvest plan and earn {interestRate}% interest in{" "}
            {duration} months
          </p>
        </div>
        <div className="silverplan">
          <h5 className="silverplan-header">Silvest Investment Plan</h5>
          <div className="silverplan-flex">
            <div className="investamount">
              <p className="flex-main">Investment Amount:</p>
              <p className="pricetag">
                {currency}
                {amount.toLocaleString()}
              </p>
            </div>
            <div className="investamount">
              <p className="flex-main">Duration:</p>
              <p className="flex-mini">{duration} Months</p>
            </div>
            <div className="investamount">
              <p className="flex-main">Start Date:</p>
              <p className="flex-mini">{moment().format("DD MMM, YYYY")}</p>
            </div>
            <div className="investamount">
              <p className="flex-main">Maturity Date:</p>
              <p className="flex-mini">
                {moment().add(duration, "months").format("DD MMM, YYYY")}
              </p>
            </div>
            <div className="investamount">
              <p className="flex-main">Interest Rate:</p>
              <p className="pricetag">{interestRate}% P/A</p>
            </div>
            <div className="investamount">
              <p className="flex-mini">Total Payout:</p>
              <p className="pricetag-mini">
                {currency}
                {estimatedReturns.toLocaleString()}
              </p>
            </div>
          </div>
        </div>
        <div className="paymentreturn-main">
          <div className="paymentreturn">
            <h5 className="silverplan-header">
              Returns Payment (Investment calculator)
            </h5>
            {Array(duration)
              .fill(null)
              .map((_, i) => {
                const isLastMonth = i + 1 === duration;
                return (
                  <div className="payment-interest" key={i}>
                    <p className="month-duration mt-5">
                      {Util.POSITIONS[i]} Month:
                    </p>
                    <p className="month-percentage mt-5">
                      {isLastMonth ? lastMonthRoi : monthlyRoi}% Interest
                      {isLastMonth && " + Capital"}
                    </p>
                  </div>
                );
              })}
          </div>
        </div>
        <div className="checkbox-main">
          <input
            type="checkbox"
            checked={hasAgreed}
            onChange={handleAgreeChange}
            name=""
            id=""
            className="checkbox-input"
          />
          <label htmlFor="" className="termsandcondition">
            By clicking this, you’ve agreed to
            <Link to="/terms">
              <span> OVest terms and conditions</span>
            </Link>
          </label>
        </div>
        <button
          className="invest"
          disabled={!hasAgreed}
          onClick={async () => {
            if (hasAgreed) {
              setPage(3);
            }
          }}
        >
          Proceed
        </button>
      </div>
    </div>
  );
};
export default ConfirmInvestment;
